import styled from "styled-components"

import { Badge, Text } from "@minuthq/meatball-ui-react"

import { ParadiseDetailsHeading } from "src/components/Paradise/ParadiseDetailsHeading"
import { TParadiseLLMPrompt } from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"
import { spacing } from "src/ui/spacing"

export function ParadiseLLMPromptDetailsMeta({
  prompt,
}: {
  prompt: TParadiseLLMPrompt
}) {
  return (
    <Wrapper>
      <ParadiseDetailsHeading>{prompt.name}</ParadiseDetailsHeading>
      {prompt.description && (
        <Text color="secondary">{prompt.description}</Text>
      )}
      {prompt.default && (
        <Badge color="info" size="x-small">
          Default in category
        </Badge>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.XS};
`
